import store from '../store';
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/order-profit/",data)
}


async function fetchOne(data) {// 获取单个
    return Request('get', "api/order-profit/view" , data);
}

// index导出
async function exports(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/order-profit/export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}
// index明细导出
async function download(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/order-profit/order-profit-detail-batch-exprot",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

// detail 导出
async function exportOne(id,data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/order-profit/export-detail/" + id,data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response

}

async function billCostAnalyze(data) {
    return Request('get', "api/order-profit/bill-cost-analyze" , data);
}

// 账单成本分析导出
async function billCostAnalyzeExport(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/order-profit/bill-cost-analyze-export", data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.billProfit_recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function billCostAnalyzeView(id) {
    return Request('get', "api/order-profit/bill-cost-analyze-view/" + id);
}

export default {
    fetch,
    fetchOne,
    exports,
    download,
    exportOne,
    billCostAnalyze,
    billCostAnalyzeExport,
    billCostAnalyzeView,
}